import React from "react";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line
import styled from "styled-components";
import { Link } from 'react-router-dom';
import Navigation from "_content/Navigation.js";
import { motion } from 'framer-motion';

import HeaderBase, {
  LogoLink as LogoLinkBase,
} from "components/headers/light.js";

import { Container as ContainerBase, ContentWithVerticalPaddingSmall, Content2Xl } from "components/misc/Layouts.js";
import { SectionHeadingSmall } from "components/misc/Headings.js";
import { SectionDescription } from "components/misc/Typography.js";
import logoImageSrc from "images/logo-light.svg";

const PrimaryBackgroundContainer = styled.div`
${tw`-mx-8 px-8 bg-primary-900 text-gray-100`}
  background-color: #1a1a1a;
  background-image:
    radial-gradient(circle at 60% 70%, rgba(15, 35, 55, 0.95) 0%, rgba(25, 45, 65, 0.90) 50%, rgba(10, 30, 50, 0) 100%, transparent 100%),
    radial-gradient(circle at 50% 50%, rgba(20, 40, 60, 0.95) 0%, transparent 100%);
`;

const Header = tw(HeaderBase)`max-w-none -mt-8 py-8 -mx-8 px-8`;
const LogoLink = tw(LogoLinkBase)`text-gray-100 -mt-4`;

const Container = tw(ContainerBase)`-mt-12`;
const Row = tw.div`flex items-start flex-col`;
const Row2 = tw.div`flex items-start flex-row`;
const Heading = tw(SectionHeadingSmall)`max-w-xxs lg:max-w-3xl lg:max-w-4xl text-left`;
const Description = tw(SectionDescription)`mt-4 lg:max-w-2xl lg:max-w-3xl text-gray-100 lg:text-base mx-auto lg:mx-0 text-left`;
const Chip = tw.span`rounded-full py-2 px-4 ml-0 lg:ml-8 mt-1 bg-yellow-1000 text-black font-medium hidden lg:block`

export default ({ translations }) => {
  const { heading, description, ctaButton, chipText } = translations.devCommunity.hero;

  const logoLink = (
   <LogoLink to={(window?.location?.href || '').includes('/es') ? "/es/" : "/"}>
      <img src={logoImageSrc} alt={translations.hero.logoAlt} width="40px" height="40px" style={{ width: "40px", height: "40px" }} />
      Gunbot
    </LogoLink>
  );
  return (
    <PrimaryBackgroundContainer>
      <Content2Xl>
        <Header logoLink={logoLink} links={<Navigation />} />
        <Container>
          <ContentWithVerticalPaddingSmall>
            <Row2>
              <Heading>{heading}</Heading>
              <Chip>{chipText}</Chip>
            </Row2>
            <Row>
              <Description>{description}</Description>
            </Row>
          </ContentWithVerticalPaddingSmall>
        </Container>
      </Content2Xl>
    </PrimaryBackgroundContainer>
  );
};